(function () {
    $(document).ready(function () {
        var is_ie = navigator.userAgent.indexOf("MSIE ") > -1 || navigator.userAgent.indexOf("Trident/") > -1;
        var is_edge = /Edge/.test(navigator.userAgent);
        $('div.component.b04-link').each(function () {
            var attribute = $(this).find('div.field-title').attr('aria-label');
            $(this).find('a').attr('aria-label', attribute);
        });


        $('div.component.b04-link').each(function () {
            var attribute = $(this).find("a > span.link-icon").attr('aria-label');
            $(this).find('a').attr('aria-label', attribute);
        });

        //9707
        $('.b04-link-bg').each(function () {
            if ($(this).attr('data-properties')) {
                var defaultColorProperties = JSON.parse($(this).attr('data-properties'));
                if (defaultColorProperties.DefaultBGColor) {
                    $(this).find(".field-title").css("background-color", defaultColorProperties.DefaultBGColor);
                }
                if (defaultColorProperties.DefaultTextColor) {
                    $(this).find('.field-title>a').css("color", defaultColorProperties.DefaultTextColor);
                }
            }
        });

        $('.b04-link-bg').on("click", function () {
            $(".b04-link-bg").each(function () {
                $(this).find(".b04-bgwrapper").removeAttr("style");
                $(this).find(".b04-bgwrapper>a").removeAttr("style");
                $(this).find(".field-title").removeClass("b04-bgwrapper");
                if ($(this).attr("data-properties")) {
                    var defaultColorProperties = JSON.parse($(this).attr("data-properties"));
                    if (defaultColorProperties.DefaultBGColor) {
                        $(this).find(".field-title").css("background-color", defaultColorProperties.DefaultBGColor);
                    }
                    if (defaultColorProperties.DefaultTextColor) {
                        $(this).find(".field-title>a").css("color", defaultColorProperties.DefaultTextColor);
                    }
                }
            });
            if ($(this).attr('data-properties')) {
                $(this).find(".field-title").addClass("b04-bgwrapper");
                var customColorProperties = JSON.parse($(this).attr('data-properties'));
                if (customColorProperties.ClickedBGColor) {
                    $(this).find(".field-title").css("background-color", customColorProperties.ClickedBGColor);
                }
                if (customColorProperties.ClickedTextColor) {
                    $(this).find('.field-title>a').css("color", customColorProperties.ClickedTextColor);
                }
            }
        });

    });
}(window.jQuery));

//from custom component

(function () {
    $(document).ready(function () {
        init();

        function init() {
            var dynamicText = '{prodNameLabel}';
            var headingElement = $('[pds-heading]');

            $('body').on('click',
                '.pds-share-link, .quick-links [data-bs-target]',
                function (e) {
                    var pageTitle = '',
                        screenTitleElement = $('.special-screen-title .special-screen-title-text .field-title'),
                        a04ScreenTitleElement = $('.a04-special-screen-title .special-screen-title-text .field-title'),
                        dataSheetElement = $(this).closest('.modal-body').find('.pull-left h3');
                    var headingText = '';
                    if ($(this).attr('document-type') != 'undefined') {
                        var pdsSdsType = $(this).attr('document-type');

                        if (pdsSdsType === 'pds') {
                            headingText = ' ' + document.getElementById("h6ProductNamePDS").getAttribute("data-pds-heading");
                        }
                    }
                    if (typeof (screenTitleElement) !== 'undefined' && screenTitleElement.length > 0) {
                        pageTitle = screenTitleElement.text();
                    }
                    else if (typeof (a04ScreenTitleElement) !== 'undefined' && a04ScreenTitleElement.length > 0) {
                        pageTitle = a04ScreenTitleElement.text();
                    }
                    else if (typeof (dataSheetElement) !== 'undefined' && dataSheetElement.length > 0) {
                        pageTitle = dataSheetElement.text() + headingText;
                    } else if (typeof (headingElement) !== "undefined" && headingElement.length > 0) {
                        pageTitle = $(headingElement).attr('pds-heading');
                    }
                    if (pageTitle == 'undefined' || pageTitle == '') {
                        pageTitle = document.title != '' ? document.title : '';
                    }

                    var id = e.currentTarget.dataset.bsTarget;
                    var targetId = $(e.currentTarget.dataset.bsTarget).find('#prodNameLabel');
                    var headingHtml = $(e.currentTarget.dataset.bsTarget).find('#prodNameLabel').html();
                    if (headingHtml && headingHtml.indexOf(dynamicText) > -1) {
                        targetId.html(sanitizeHtmlStrings(headingHtml.replace('{prodNameLabel}',
                            '<span class="dynamic-text">' + pageTitle + '</span>')));
                    } else {
                        targetId.find('.dynamic-text').text(pageTitle);
                    }

                    if ($("textarea[data-sc-field-name='txtSubject']") && $("textarea[data-sc-field-name='txtSubject']").length > 0) {
                        $("textarea[data-sc-field-name='txtSubject']").text(pageTitle);
                    } else {
                        $("input[data-sc-field-name='txtSubject']").val(pageTitle);
                    }
                    var txtSubjectSection = $('.txtSubject_section');
                    if (txtSubjectSection !== 'undefined' && txtSubjectSection.length > 0) {
                        txtSubjectSection.text(pageTitle);
                    }
                    //pds share url
                    var shareUrl = '';
                    var linkElement = $(this).closest('.div-table-row').find('[title="File"]').eq(0);
                    if (linkElement && linkElement != 'undefined') {
                        shareUrl = $(linkElement).attr('href');
                        if ($("input[data-sc-field-name='shareDocumentUrl']") != 'undefined') {
                            $("input[data-sc-field-name='shareDocumentUrl']").val(shareUrl);
                        }
                    } else {
                        linkElement = $(this).closest('.div-table-row').find('[title="File"]').eq(2);
                        if (linkElement && linkElement != 'undefined') {
                            shareUrl = $(linkElement).attr('href');
                            if ($("input[data-sc-field-name='shareDocumentUrl']") != 'undefined') {
                                $("input[data-sc-field-name='shareDocumentUrl']").val(shareUrl);
                            }
                        }
                    }
                }
            );
        }
    });
}(window.jQuery));


// b04 button/*Analytics*/
analytics.eventConfig.push(
    {
        "target": ".component.b04-link:not([data-bs-toggle*=modal])",
        "codeId": "b04",
        "events": [
            {
                "eventTarget": "a[href*=\\http]",
                "eventType": "click",
                "tags": {
                    "componentId": "b04",
                    "componentName": "link",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "generic link",
                    "event": [
                        {
                            "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pds') !== -1 || $(context).attr('href').toLowerCase().search('psims') !== -1)",
                            "value": "download"
                        },
                        {
                            "rule": "true",
                            "value": "outbound"
                        }
                    ],
                    "eventType": [
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('pds') !== -1",
                            "value": "pds download click"
                        },
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('psims') !== -1",
                            "value": "sds download click"
                        },
                        {
                            "rule": "true",
                            "value": "outbound click"
                        }
                    ],
                    "fileName": "",
                    "parentListSource": "",
                    "parentName": "",
                    "parentOrdinal": "",
                    "parentTitle": "",
                    "titleText": ""
                }
            },
            {
                "eventTarget": "a:not([href*=\\http], [data-bs-toggle*=modal])",
                "eventType": "click",
                "tags": {
                    "componentId": "b04",
                    "componentName": "link",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "generic link",
                    "event": [
                        {
                            "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().startsWith('mailto:') || $(context).attr('href').toLowerCase().startsWith('tel'))",
                            "value": "contact"
                        },
                        {
                            "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                            "value": "download"
                        },
                        {
                            "rule": "true",
                            "value": "navigation"
                        }
                    ],
                    "eventType": [
                        {
                            "rule": "$(context).attr('href') && ($(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:'))",
                            "value": "click to email"
                        },
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('tel')",
                            "value": "click to call"
                        },
                        {
                            "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                            "value": "other media asset click"
                        },
                        {
                            "rule": "true",
                            "value": "link internal navigation click"
                        }
                    ],
                    "fileName": "",
                    "parentListSource": "",
                    "parentName": "",
                    "parentOrdinal": "",
                    "parentTitle": ""
                }
            }
        ]
    }
)